












import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import SuperUserForm from '@superUI/Forms/SuperUserForm'
import RequestButton from '@components/RequestButton'

settings =
  name: "SuperUserCreate"
  components: { Back, SuperContainerView, SuperUserForm, RequestButton }
  resources:
    newSuperUser:
        resourceName: 'super_user'
        slug: 'super_users/new'
  vue:
    methods:
      onSave: (item) -> @$router.push({ name: 'SuperUserListPage' })

export default VueOptions.vue settings
